import { CommonResponse, deleteData, get, post, put } from './common.ts'

/**
 * (01)
 * 차시 조회
 */

// GET /sessions/{courseId}
interface GetSessionsRequest {
  courseId: string
  onlyCompleted: boolean
  orderBy: string
}
interface GetSessionsResponse {
  week: number
  sessions: {
    id: number
    description: string
    week: number
    order: number
    dayOfWeek: string
    period: number
    status: string
    courseId: string
    startDate: string
  }[]
}

export const getSessions = async (
  request: GetSessionsRequest,
): Promise<CommonResponse<GetSessionsResponse>> => {
  const onlyCompleted = request.onlyCompleted ? `?onlyCompleted=${request.onlyCompleted}` : ''
  const orderBy = request.orderBy ? `&orderBy=${request.orderBy}` : ''
  return await get(`/sessions/${request.courseId}${onlyCompleted}${orderBy}`)
}

/**
 * (02)
 * 가능한 주차 조회
 */

// GET /sessions/{semesterId}/available-weeks
interface GetSessionsAvailableWeeksRequest {
  semesterId: string
}
interface GetSessionsAvailableWeeksResponse {}

export const getSessionsAvailableWeeks = async (
  request: GetSessionsAvailableWeeksRequest,
): Promise<CommonResponse<GetSessionsAvailableWeeksResponse>> => {
  return await get(`/sessions/${request.semesterId}/available-weeks`)
}

/**
 * (03)
 * 가능한 요일 조회
 */

// GET /sessions/{semesterId}/{week}/available-days
interface GetSessionsAvailableDayRequest {
  semesterId: string
  week: number
}
interface GetSessionsAvailableDayResponse {}

export const getSessionsAvailableDay = async (
  request: GetSessionsAvailableDayRequest,
): Promise<CommonResponse<GetSessionsAvailableDayResponse>> => {
  return await get(`/sessions/${request.semesterId}/${request.week}/available-day`)
}

/**
 * (04)
 * 가능한 교시 조회
 */

// GET /sessions/{courseId}/{week}/available-period
interface GetSessionsAvailablePeriodRequest {
  courseId: string
  week: number
  day: string
}
interface GetSessionsAvailablePeriodResponse {}
export const getSessionsAvailablePeriod = async (
  request: GetSessionsAvailablePeriodRequest,
): Promise<CommonResponse<GetSessionsAvailablePeriodResponse>> => {
  return await get(`/sessions/${request.courseId}/${request.week}/${request.day}/available-period`)
}

/**
 * (05)
 * 차시 생성
 */

// POST /sessions
interface PostSessionsRequest {
  description: string
  week: number
  dayOfWeek: string
  period: number
  courseId: string
}

export const postSessions = async (body: PostSessionsRequest): Promise<CommonResponse<null>> => {
  return await post('/sessions', body)
}

/**
 * (06)
 * 차시 수정
 */

// PUT /sessions/{sessionId}
interface PutSessionsRequestParams {
  sessionId: string
}
interface PutSessionsRequestBody {
  description: string
  week: number
  dayOfWeek: string
  period: number
}

export const putSessions = async (
  request: PutSessionsRequestParams,
  body: PutSessionsRequestBody,
): Promise<CommonResponse<null>> => {
  return await put(`/sessions/${request.sessionId}`, body)
}

/**
 * (07)
 * 차시 삭제
 */

// DELETE /sessions/{sessionId}
interface DeleteSessionsRequest {
  sessionId: string
}

export const deleteSessions = async (
  body: DeleteSessionsRequest,
): Promise<CommonResponse<null>> => {
  return await deleteData(`/sessions/${body.sessionId}`, body)
}

/**
 * (08)
 * 특정 차시 하위 보드 가져오기
 */

// GET /sessions/{sessionId}/board
interface GetSessionsBoardRequest {
  sessionId: string
}
interface GetSessionsBoardResponse {
  id: string
  pageNum: number
  backgroundImageId: string
  backgroundImageUrl: string
  classroomId: string
}

export const getSessionsBoard = async (
  request: GetSessionsBoardRequest,
): Promise<CommonResponse<GetSessionsBoardResponse>> => {
  return await get(`/sessions/${request.sessionId}/board`)
}

/**
 * (09)
 * 수정 가능한 교시 조회
 */

// GET /sessions/{sessionId}/{week}/{day}/editable-period
interface GetSessionsEditablePeriodRequest {
  sessionId: string
  week: number
  day: string
}
interface GetSessionsEditablePeriodResponse {}
export const getSessionsEditablePeriod = async (
  request: GetSessionsEditablePeriodRequest,
): Promise<CommonResponse<GetSessionsEditablePeriodResponse>> => {
  return await get(`/sessions/${request.sessionId}/${request.week}/${request.day}/editable-period`)
}
